import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


export const gteShoplist = createAsyncThunk("/list-shop", async(reqbody) => {



    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };

    const response = await fetch(process.env.REACT_APP_API_URL + "api6/shoplisting", requestOptions);
    const respdata = await response.json();
    return respdata;
});
////////////////////////////////// Delete multiple User form Table //////////////////////////////////


export const deletemultyple = createAsyncThunk("shop-list-delete", async(reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/deleteshopmany", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

////////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const editmultyple = createAsyncThunk("shop-list-edit", async(reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/shopeditmultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});
////////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const shopPermission = createAsyncThunk("shop-list-permission", async(reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/shopeditmultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

////////////////////////////////// Get Manager Details form Table //////////////////////////////////
export const getUserDetails = createAsyncThunk("user-details", async(reqbody) => {
    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/getuserdetails", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
})


const shopManagement = createSlice({
    name: 'shopmanagement',
    initialState: {
        submitting: false,
        submitted: false,
        message: null,
        // loading: {},
        loading: false,
        success: false,
        successmsg: "",
        shopList: [],
        managerData: []
    },
    reducers: {
        setSuccessAfterSubmit(state, action) {
            state.success = false;
        },
        setManagerEmpty(state, action) {
            console.log("action empty 666", action)
            state.managerData = [];
        }
    },
    extraReducers: {

        [gteShoplist.rejected]: (state, action) => {
            state.loading = false;
        },
        [gteShoplist.pending]: (state, action) => {
            // state.ShopList = [];
            state.loading = true;
        },
        [gteShoplist.fulfilled]: (state, action) => {
            console.log("action f", action)
            if (action.payload.status === 'success') {
                // state.shopList = [...action.payload.results.res];
                state.shopList = [...state.shopList,...action.payload.results.res];
                state.message = action.payload.status;
                state.loading = false;

            }
        },

        //////////////////////////// Delete Multiple User ///////////////////////////////
        [deletemultyple.pending]: (state, action) => {

            state.loading = true;
        },
        [deletemultyple.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Deleted Successfully';
                state.success = true;
            }

        },
        [deletemultyple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        //////////////////////////// Edit Multiple Item ///////////////////////////////
        [editmultyple.pending]: (state, action) => {
            state.loading = true;
        },
        [editmultyple.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully';
                state.success = true;
            }
        },
        [editmultyple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },


        //////////////////////for manager details//////////////////////
        [getUserDetails.pending]: (state, action) => {
            state.loading = true
        },
        [getUserDetails.fulfilled]: (state, action) => {
            // console.log('action user details 333',action)
            if (action.payload.status === "success") {
                state.loading = false;
                state.success = true;
                state.managerData = action.payload.result;
            }
        },
        [getUserDetails.rejected]: (state, action) => {
            state.loading = false;
            state.success = false;
            state.successmsg = '';
        },

        ///////////for permission change///////////////////////
        [shopPermission.pending]: (state, action) => {
            state.loading = true;
        },
        [shopPermission.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully';
                state.success = true;
            }
        },
        [shopPermission.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
    }
})


export default shopManagement.reducer;
export const { setSuccessAfterSubmit, setManagerEmpty } = shopManagement.actions;